import { jsx } from "react/jsx-runtime";
import { Link } from "pcln-design-system";
import "react";
import { flightRateOptionsManager } from "./flightRateOptionsManager.js";
const FlightDetailLink = ({ rateId })=>{
    const flight = flightRateOptionsManager.getFlightRateByRateId(rateId);
    if (!flight) return /*#__PURE__*/ jsx(Link, {
        href: "#",
        children: "View Flight"
    });
    if (flight && flight.detailLink) return /*#__PURE__*/ jsx(Link, {
        href: flight.detailLink,
        target: "_blank",
        children: "View Flight"
    });
    if (flight && flight.clientRedirectUrl) return /*#__PURE__*/ jsx(Link, {
        href: flight.clientRedirectUrl,
        target: "_blank",
        children: "View Flight"
    });
    return null;
};
export { FlightDetailLink };
